export interface IChangeOrderModel {
    id: string;
    number: string;
    description: string;
    date: string;
    amount: number;
	documents: Object;
}

// <editor-fold> Document models

export class ChangeOrderModel implements IChangeOrderModel {
    id: string = null;
    number: string = null;
    description: string = null;
    date: string = null;
    amount: number = null;
    documents: Object;
}

// </editor-fold>
